import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { hasConditionalPages, getConditionalFunction } from './conditional-pages';

export const getPageNext = async (formConfig: FormConfig, formValues: FormValues, pageIdCur: string) => {
    const { formId, pages } = formConfig;

    const currentPageIndex = pages.findIndex((page) => page.pageId === pageIdCur);

    if (currentPageIndex === undefined) {
        throw new Error('Unknown pageIdCur: ' + pageIdCur);
    }

    const isLastPage = currentPageIndex === formConfig.pages.length - 1;

    // There cannot be a next-page if the user is on the last page
    if (isLastPage) {
        return undefined;
    }

    if (hasConditionalPages(formId)) {
        const nextPage = await getNextPageConditionally(formId, pageIdCur, formConfig, formValues);

        return nextPage;
    }

    return getNextPageFromArray(formConfig, currentPageIndex);
};

const getNextPageFromArray = (formConfig: FormConfig, currentPageIndex: number) => {
    const { pages } = formConfig;

    return pages[currentPageIndex + 1].pageId;
};

const getNextPageConditionally = async (
    formId: string,
    pageIdCur: string,
    formConfig: FormConfig,
    formValues: FormValues
) => {
    const getNextPageFuncReference = getConditionalFunction(formId);

    const nextPage = await getNextPageFuncReference(pageIdCur, formConfig, formValues);

    return nextPage;
};
